'use client';
import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useCallback, useMemo, Children, isValidElement } from 'react';
import styled, { css } from 'styled-components';
import { switchProp } from 'styled-tools';
import { withTitan } from '../../hocs/withTitan/withTitan.js';
import { useBinding } from '../../hooks/useBinding/useBinding.js';
import { defaultStyles } from '../../mixins/defaultStyles.js';
import { rem } from '../../mixins/rem.js';
import { spaceProp } from '../../mixins/spaceProp.js';
import { spacing } from '../../mixins/spacing.js';
import { Flex } from '../Flex/Flex.js';
import { IconButton } from '../IconButton/IconButton.js';
import '../Icons/AlignStartHorizontalIcon.js';
import '../Icons/ArchiveIcon.js';
import '../Icons/ArrowDownIcon.js';
import '../Icons/ArrowLeftBottomIcon.js';
import '../Icons/ArrowLeftIcon.js';
import '../Icons/ArrowLeftTopIcon.js';
import '../Icons/ArrowRightBottomIcon.js';
import '../Icons/ArrowRightIcon.js';
import '../Icons/ArrowRightTopIcon.js';
import '../Icons/BagIcon.js';
import '../Icons/BasketIcon.js';
import '../Icons/BellFilledIcon.js';
import '../Icons/BellNotificationIcon.js';
import '../Icons/BellOutlineIcon.js';
import '../Icons/BinocularsIcon.js';
import '../Icons/BlocksIcon.js';
import '../Icons/BoltIcon.js';
import '../Icons/BookIcon.js';
import '../Icons/BookmarkAddFilledIcon.js';
import '../Icons/BookmarkAddOutlineIcon.js';
import '../Icons/BookmarkIcon.js';
import '../Icons/BookOpenedIcon.js';
import '../Icons/BoxAltIcon.js';
import '../Icons/BusinessIcon.js';
import '../Icons/CalendarIcon.js';
import '../Icons/CancelIcon.js';
import '../Icons/CardsIcon.js';
import '../Icons/ChatAltIcon.js';
import '../Icons/ChatIcon.js';
import '../Icons/CheckboxIcon.js';
import '../Icons/CheckCirlcleFilledIcon.js';
import '../Icons/CheckSquareIcon.js';
import '../Icons/ChevronDoubleLeftIcon.js';
import '../Icons/ChevronDoubleRightIcon.js';
import '../Icons/ChevronDownIcon.js';
import '../Icons/ChevronLeftIcon.js';
import '../Icons/ChevronRightIcon.js';
import '../Icons/ChevronUpIcon.js';
import '../Icons/ClipboardEditIcon.js';
import '../Icons/ClipboardIcon.js';
import { CloseIcon } from '../Icons/CloseIcon.js';
import '../Icons/CollapseIcon.js';
import '../Icons/ControlsIcon.js';
import '../Icons/ControlsVerticalAltIcon.js';
import '../Icons/CopyIcon.js';
import '../Icons/CutIcon.js';
import '../Icons/DangerIcon.js';
import '../Icons/DownloadCloudIcon.js';
import '../Icons/DownloadIcon.js';
import '../Icons/DownloadPdfIcon.js';
import '../Icons/DrawerOpenIcon.js';
import '../Icons/EllipsisIcon.js';
import '../Icons/EllypsisVerticalIcon.js';
import '../Icons/EnvelopeIcon.js';
import '../Icons/ErrorIcon.js';
import '../Icons/ExitIcon.js';
import '../Icons/ExpandIcon.js';
import '../Icons/ExternalLinkIcon.js';
import '../Icons/EyeCrossedIcon.js';
import '../Icons/EyeIcon.js';
import '../Icons/FacebookIcon.js';
import '../Icons/FavouriteIcon.js';
import '../Icons/FileBadgeIcon.js';
import '../Icons/FileIcon.js';
import '../Icons/FileSearchIcon.js';
import '../Icons/FileType2Icon.js';
import '../Icons/FilmIcon.js';
import '../Icons/FitscreenIcon.js';
import '../Icons/FocusIcon.js';
import '../Icons/FolderAddIcon.js';
import '../Icons/FolderClosedIcon.js';
import '../Icons/FolderIcon.js';
import '../Icons/FutureIcon.js';
import '../Icons/GalleryVerticalEndIcon.js';
import '../Icons/GridIcon.js';
import '../Icons/HelpIcon.js';
import '../Icons/HistoryIcon.js';
import '../Icons/HomeIcon.js';
import '../Icons/InformationIcon.js';
import '../Icons/InstagramIcon.js';
import '../Icons/LibraryIcon.js';
import '../Icons/LightbulbIcon.js';
import '../Icons/LinkedinIcon.js';
import '../Icons/ListIcon.js';
import '../Icons/ListSearchIcon.js';
import '../Icons/Loader2Icon.js';
import '../Icons/LockAltIcon.js';
import '../Icons/LockAltOpenIcon.js';
import '../Icons/LockIcon.js';
import '../Icons/LockOpenIcon.js';
import '../Icons/MagazineIcon.js';
import '../Icons/MailIcon.js';
import '../Icons/Maximize2Icon.js';
import '../Icons/MenuCollapsable2Icon.js';
import '../Icons/MenuCollapsableIcon.js';
import '../Icons/MenuDotsIcon.js';
import '../Icons/MenuIcon.js';
import '../Icons/MinusIcon.js';
import '../Icons/NewsIcon.js';
import '../Icons/NtfrIcon.js';
import '../Icons/OkCircleIcon.js';
import '../Icons/OkIcon.js';
import '../Icons/PencilIcon.js';
import '../Icons/PenSquareIcon.js';
import '../Icons/People2Icon.js';
import '../Icons/PeopleIcon.js';
import '../Icons/PersonIcon.js';
import '../Icons/PhoneCallIcon.js';
import '../Icons/PlayFilledIcon.js';
import '../Icons/PlayIcon.js';
import '../Icons/PlusCircleIcon.js';
import '../Icons/PlusIcon.js';
import '../Icons/PlusSquareIcon.js';
import '../Icons/PrintIcon.js';
import '../Icons/RadioIcon.js';
import '../Icons/RefreshCwIcon.js';
import '../Icons/RotateIcon.js';
import '../Icons/SearchIcon.js';
import '../Icons/SettingsIcon.js';
import '../Icons/ShareIcon.js';
import '../Icons/ShieldIcon.js';
import '../Icons/SocialXIcon.js';
import '../Icons/StarFilledIcon.js';
import '../Icons/StarOutlineIcon.js';
import '../Icons/StickyNoteIcon.js';
import '../Icons/SwapHorizontalIcon.js';
import '../Icons/TablePropertiesIcon.js';
import '../Icons/TasklistIcon.js';
import '../Icons/ThumbDownIcon.js';
import '../Icons/ThumbsDownIcon.js';
import '../Icons/ThumbsUpIcon.js';
import '../Icons/ThumbUpIcon.js';
import '../Icons/TimeIcon.js';
import '../Icons/TimerIcon.js';
import '../Icons/Trash2Icon.js';
import '../Icons/TrashIcon.js';
import '../Icons/UpgradeIcon.js';
import '../Icons/UploadIcon.js';
import '../Icons/UserIcon.js';
import '../Icons/VideoIcon.js';
import '../Icons/WorldIcon.js';
import '../Icons/XposiIcon.js';
import '../Icons/YoutubeIcon.js';
import { Link } from '../Link/Link.js';
import { Text } from '../Text/Text.js';

const StyledContainer = styled.div.withConfig({
  componentId: "sc-1s32vv6-0"
})(["", ";display:flex;", " background-color:", ";border-radius:", ";padding:", ";"], defaultStyles.boxSizing, ({
  spaceAfter
}) => spaceProp(spaceAfter), ({
  theme,
  colorScheme
}) => theme.components.statusMessage.variant[colorScheme].backgroundColor, ({
  theme,
  isRounded
}) => isRounded ? theme.components.statusMessage.cornerRounding : 0, ({
  theme
}) => `${theme.components.statusMessage.spacing.container.paddingVertical} ${theme.components.statusMessage.spacing.container.paddingHorizontal}`);
const StyledContentWrapper = styled.div.withConfig({
  componentId: "sc-1s32vv6-1"
})(["", ";color:", ";display:flex;align-items:flex-start;width:100%;", ";", ";a,button{color:", ";&:hover,&:focus{color:", ";}}"], defaultStyles.fontSmoothing, ({
  theme,
  colorScheme
}) => theme.components.statusMessage.variant[colorScheme].foregroundColor, ({
  isCloseable,
  alignment
}) => isCloseable && alignment === 'center' && css(["padding-left:8px;"]), switchProp('alignment', {
  left: css(["justify-content:flex-start;"]),
  center: css(["justify-content:center;"])
}), ({
  theme,
  colorScheme
}) => theme.components.statusMessage.variant[colorScheme].foregroundColor, ({
  theme,
  colorScheme
}) => theme.components.statusMessage.variant[colorScheme].foregroundColor);
const StyledCloseButton = styled(IconButton).withConfig({
  componentId: "sc-1s32vv6-2"
})(["margin-left:", ";margin-top:", ";color:", ";align-items:flex-start;"], spacing(2), rem(2), ({
  theme,
  colorScheme
}) => theme.components.statusMessage.variant[colorScheme].foregroundColor);
const StyledIconWrapper = styled(Flex).withConfig({
  componentId: "sc-1s32vv6-3"
})(["margin-right:", ";margin-top:", ";color:", ";"], spacing(2), rem(3), ({
  theme,
  colorScheme
}) => theme.components.statusMessage.variant[colorScheme].foregroundColor);
const StatusMessage = /*#__PURE__*/withTitan((_a, ref) => {
  var {
      isShown: isShownProvided,
      defaultIsShown,
      isCloseable,
      icon,
      type = 'default',
      onClose: onMessageClose,
      children,
      link,
      testId = 'statusMessage',
      labelClose = 'Sluiten'
    } = _a,
    props = __rest(_a, ["isShown", "defaultIsShown", "isCloseable", "icon", "type", "onClose", "children", "link", "testId", "labelClose"]);
  const [isShown, setShown] = useBinding(defaultIsShown, isShownProvided, onMessageClose, true);
  const onClose = useCallback(() => {
    setShown(false);
  }, [setShown]);
  /** We want to know if there is any <Link> component within the children */
  const hasLinkInChildren = useMemo(() => {
    const arr = Children.toArray(children);
    /** We determine the children contain a Link based on the presence of the 'to' prop */
    return arr.some(child => isValidElement(child) && (child.props.to || child.props.onClick));
  }, [children]);
  if (!isShown) return null;
  return jsxs(StyledContainer, Object.assign({
    ref: ref,
    colorScheme: type,
    "data-test-id": testId
  }, props, {
    children: [jsxs(StyledContentWrapper, Object.assign({
      colorScheme: type
    }, props, {
      children: [icon && jsx(StyledIconWrapper, {
        "aria-hidden": "true",
        colorScheme: type,
        "data-test-id": `${testId}Icon`,
        children: icon
      }), hasLinkInChildren || !link ? jsx(Text, {
        type: "label",
        children: children
      }) : jsx(Link, Object.assign({}, link, {
        children: children
      }))]
    })), isCloseable && jsx(StyledCloseButton, {
      colorScheme: type,
      icon: jsx(CloseIcon, {}),
      label: labelClose,
      padding: 0.5,
      size: 12,
      testId: `${testId}CloseButton`,
      variant: "primary",
      onClick: onClose
    })]
  }));
}, {
  name: 'StatusMessage'
});

export { StatusMessage };
//# sourceMappingURL=StatusMessage.js.map
